<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Add User Role</h4>
            <new-user-role-form button_text="Add User Role" @roleAction="roleAction"/>
          </div>
        </div>
      </div>
      <div class="col-lg-8">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">All User Roles</h4>
            <user-roles-table :rows="roles"/>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "@/router/layouts/main"
import PageHeader from "@/components/page-header";
import UserRolesTable from "@/components/roles/user-roles-table"
import NewUserRoleForm from "@/components/roles/new-user-role-form";

export default {
  page: {
    title: "User Roles",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {NewUserRoleForm, UserRolesTable, PageHeader, Layout},
name: "user-roles",
  data() {
    return {
      title: "User Roles",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "User Role",
          active: true
        }
      ],
      roles:[
        {
          "created_at": "Mon, 12 Feb 2018 11:46:29 GMT",
          "description": "Jomo Kenyatta International Airport",
          "lat": null,
          "longi": null,
          "manager_id": null,
          "name": "JKIA",
          "public_id": "cfa748b0-607b-4dfd-88cb-a1c5e6c7209f",
          "session_id": "default",
          "status": 5
        },
        {
          "created_at": "Mon, 12 Feb 2018 11:46:29 GMT",
          "description": "KEA Trading Kindaruma Business Center offices",
          "lat": null,
          "longi": null,
          "manager_id": null,
          "name": "Kindaruma Business Center",
          "public_id": "ff62ec35-fbb9-44da-a32a-adb968e5faa8",
          "session_id": "default",
          "status": 5
        }
      ]
    }
  },
  methods: {
    roleAction(){
      console.log('add role')
    }
  }
}
</script>

<style scoped>

</style>
